"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.function.name.js");
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _reduxForm = require("redux-form");
var _refs = require("./refs");
var _components = require("../components");
var _excluded = ["component", "fieldComponent"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FieldsetWrapper = function FieldsetWrapper(_ref) {
  var children = _ref.children,
    isMutuallyExclusiveAnswers = _ref.isMutuallyExclusiveAnswers;
  return isMutuallyExclusiveAnswers ? /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleFieldset, {
    error: false
  }, children) : children;
};

/**
 * @type {<P>(Component: React.ComponentType<P>) => React.ForwardRefExoticComponent<P>}
 */
var withFieldWrapper = function withFieldWrapper(Component) {
  var componentHandlesOwnErrors = !!Component.handlesErrorDisplay;
  var WrappedComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
    var _props$config, _props$config2, _props$config3, _props$meta, _ref2, _props$valuesFromRedu, _props$valuesFromRedu2, _props$config4, _props$config4$values;
    var divRef = (0, _react.useRef)(null);
    var componentRef = (0, _react.useRef)(null);
    var registeredFields = props.registeredFields;
    var mutually_exclusive_answers = (props === null || props === void 0 ? void 0 : props.mutually_exclusive_answers) || (props === null || props === void 0 ? void 0 : (_props$config = props.config) === null || _props$config === void 0 ? void 0 : _props$config.mutually_exclusive_answers);
    var possible_answers = (props === null || props === void 0 ? void 0 : props.options) || ((_props$config2 = props.config) === null || _props$config2 === void 0 ? void 0 : _props$config2.options);
    var dispatch = (props === null || props === void 0 ? void 0 : (_props$config3 = props.config) === null || _props$config3 === void 0 ? void 0 : _props$config3.dispatch) || (props === null || props === void 0 ? void 0 : (_props$meta = props.meta) === null || _props$meta === void 0 ? void 0 : _props$meta.dispatch);
    (0, _react.useEffect)(function () {
      // if the component has mutually_exclusive_answers
      // register a field in redux-form with the format 'field_name_exclusive'
      // these fields will overwrite the original value on submission AFTER validation
      if (mutually_exclusive_answers) {
        if (!(registeredFields !== null && registeredFields !== void 0 && registeredFields["".concat(props.input.name, "_exclusive")])) {
          dispatch((0, _reduxForm.registerField)(props.meta.form, "".concat(props.input.name, "_exclusive"), 'Field'));
        }
      }
    }, [props.meta.form, props.input.name, props.input.value, mutually_exclusive_answers, registeredFields, dispatch]);
    var handleClearExclusiveOnChange = function handleClearExclusiveOnChange(v) {
      if (v && dispatch) {
        dispatch((0, _reduxForm.change)(props.meta.form, "".concat(props.input.name, "_exclusive"), '', false, false));
        props.input.onChange(v);
      }
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: forwardedRef && function (ref) {
        divRef.current = ref;
        // The 'div' ref acts as a default in case the component ref doesn't
        //   exist (i.e. it doesn't forward it), so we only want to forward to
        //   the div if the component ref does not exist.
        if (!componentRef.current) {
          (0, _refs.setRef)(forwardedRef, ref);
        }
      },
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/_react["default"].createElement(FieldsetWrapper, {
      isMutuallyExclusiveAnswers: !!mutually_exclusive_answers && !props["interface"] === 'checkboxgroupwithnone'
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
      input: mutually_exclusive_answers ? _objectSpread(_objectSpread({}, props.input), {}, {
        onChange: handleClearExclusiveOnChange
      }) : props.input,
      config: _objectSpread(_objectSpread({}, props.config), {}, {
        mutually_exclusive_answers: mutually_exclusive_answers,
        input: _objectSpread(_objectSpread({}, props.config.input), {}, {
          onChange: handleClearExclusiveOnChange
        })
      }),
      ref: forwardedRef && function (ref) {
        componentRef.current = ref;
        if (ref ||
        // If the div ref is undefined as well, that means we're probably
        //   being unmounted.
        !divRef.current) {
          (0, _refs.setRef)(forwardedRef, ref);
        }
      }
    })), mutually_exclusive_answers && /*#__PURE__*/_react["default"].createElement("div", null, props["interface"] !== 'checkboxgroupwithnone' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "exclusive-answers-divider"
    }), /*#__PURE__*/_react["default"].createElement(_components.RadioGroup, {
      label: "",
      config: {
        options: mutually_exclusive_answers,
        supressErrorMessage: true,
        isMutuallyExclusiveAnswers: !!mutually_exclusive_answers
      },
      input: {
        name: "".concat(props.input.name, "_exclusive"),
        onChange: function onChange(evt) {
          dispatch((0, _reduxForm.change)(props.meta.form, "".concat(props.input.name, "_exclusive"), evt));
          props.input.onChange(possible_answers && props["interface"] !== 'radioinput' ? [''] : 'set_by_exclusive_input');
        },
        defaultValue: props.input.value,
        value: (_ref2 = (_props$valuesFromRedu = props === null || props === void 0 ? void 0 : (_props$valuesFromRedu2 = props.valuesFromRedux) === null || _props$valuesFromRedu2 === void 0 ? void 0 : _props$valuesFromRedu2["".concat(props.input.name, "_exclusive")]) !== null && _props$valuesFromRedu !== void 0 ? _props$valuesFromRedu : props === null || props === void 0 ? void 0 : (_props$config4 = props.config) === null || _props$config4 === void 0 ? void 0 : (_props$config4$values = _props$config4.valuesFromRedux) === null || _props$config4$values === void 0 ? void 0 : _props$config4$values["".concat(props.input.name, "_exclusive")]) !== null && _ref2 !== void 0 ? _ref2 : ''
      },
      meta: props.meta
    }))), props.meta.error && props.meta.touched && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !componentHandlesOwnErrors && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
      "data-e2e-test-id": "field-validation-error-".concat(props.input.name)
    }, props.meta.error)))));
  });
  WrappedComponent.displayName = "withFieldWrapper(".concat(Component.displayName || Component.name, ")");
  return WrappedComponent;
};

/**
 * Wraps the official Redux Form `Field` component to provide three things:
 *
 * 1. Wraps the given component in a "ref wrapper" and forwards the ref to the
 *   component, if possible, or to a wrapper div element otherwise. This is
 *   intended to always give the parent a valid ref whether or not the component
 *   exposes one.
 *
 * 2. Handles the display of validation errors if the component does not
 *   advertise that it does this via the `handlesErrorDisplay` attribute. Also
 *   handles displaying the warning icon next to the field when it has a
 *   validation error.
 *
 * 3. Handles mutually exclusive answers by providing a component
 *    below the original field that can interact with the field.
 *
 * This should always be used instead of the Redux Form `Field` component unless
 *   you need to do something custom for some reason.
 *
 * @param {*} props The same props you would normally pass to `Field`.
 * @param {React.ComponentType<any>} [props.fieldComponent] The component to
 *   render as the field wrapper. Defaults to Redux Form's `Field` component,
 *   but is useful to override for mocking.
 */
var FieldWrapper = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var component = _ref3.component,
    _ref3$fieldComponent = _ref3.fieldComponent,
    FieldComponent = _ref3$fieldComponent === void 0 ? _reduxForm.Field : _ref3$fieldComponent,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  component = (0, _react.useMemo)(function () {
    return component ? withFieldWrapper(component) : undefined;
  }, [component]);
  return /*#__PURE__*/_react["default"].createElement(FieldComponent, (0, _extends2["default"])({}, props, {
    component: component,
    forwardRef: true,
    ref: ref
  }));
});
var _default = exports["default"] = FieldWrapper;